import { useState, useEffect } from "react";

import DragNDrop from "./DragNDrop";
import ImageDisplay from "./ImageDisplay";
import ImageLoader from "./ImageLoader";

// Setup Use of API
import useApi from '../../hooks/useApi';
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { data } from "react-router-dom";
import useSettings from "../../hooks/useSettings";

const Upload = ({ value, onChange, dataItems }) => {
    const queryClient = useQueryClient();
    const [files, setFiles] = useState([])

    const { initializeSettings } = useSettings()

    //Setting up API 
    const { getMe, getMeStream, deleteMe, postMeForm } = useApi();


    useEffect((
    ) => {
        if (files.length > 0 && !value) {
            saveFile()
        }
    }, [files])


    const saveFile = async () => {
        const savedFile = await postMeForm('file', files[0], dataItems)
        //Save the new Reference on the Form
        onChange(
            { target: { name: dataItems.id, value: savedFile.data.record.id } })
        if (dataItems.table === 'settings') {
            initializeSettings(dataItems.endpoint)
        }

    }

    const handleReload = async () => {
        const record = await getMe(`${dataItems.endpoint}`)
        onChange({ target: { name: dataItems.id, value: record.data[dataItems.id] } })
    }


    //Api Retrieval function to get list
    const getData = async (key) => {
        const fileId = key.queryKey[1];
        const resource = `file/${fileId}?render=logo`;

        try {
            const file = await getMeStream(resource);

            // Check if blob is not empty before updating the array
            if (file && file.size > 0) {
                return file;
            } else {
                // Handle the case when the blob is empty or null
                console.log('Received empty or null blob.');
                handleReload()
                queryClient.invalidateQueries(['salesSettings']);
                console.log('Value:', value)
                return null;
            }
        } catch (error) {
            // Handle the error from getMeStream
            console.error('Error getting data:', error);
            return null;
        }
    };


    //Request to get file from API 
    const result = useQuery({
        queryKey: ['files', value],
        queryFn: getData,
        enabled: !!value // Only run query if value exists and is not empty
    })

    // Handle successful data with useEffect since onSuccess is deprecated in v5
    useEffect(() => {
        if (result.isSuccess) {
            const file = result.data;
            if (file !== undefined) setFiles((prevFiles) => [file])
            if (file === undefined) setFiles([])
        }
    }, [result.isSuccess, result.data]);

    const handleDelete = async () => {
        // Name the field letting go: the same image may be held elsewhere
        // (task 38.02 §2.4), and only this holder's reference is cleared.
        if (value) {
            const { table, fieldId, field } = dataItems
            const ref = table && fieldId && field ? `?${new URLSearchParams({ table, fieldId, field })}` : ''
            await deleteMe('file', `${value}${ref}`)
        }
        setFiles([])
        onChange(
            { target: { name: dataItems.id, value: '' } })
        if (dataItems.table === 'settings') {
            initializeSettings(dataItems.endpoint)
        }
    }



    if (result.isLoading) {
        return <span>Loading...</span>
    }

    if (result.isError) {
        return <span>Error: {result.error ? result.error.message : 'Internet Issues'}</span>
    }

    // Render the component regardless of query state since query might be disabled
    return (
        <div>
            {!value && files.length <= 0 && <DragNDrop width='300px' onFilesSelected={setFiles} />}
            {value && files.length <= 0 && <ImageLoader />}
            {files.length > 0 && <ImageDisplay source={files[0]} onDelete={handleDelete} />}
        </div>
    )
}

export default Upload
